import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import AnimatedSection from '../Animation/AnimatedSection';

const TestimonialsSection = styled.section`
  padding: 6rem 0;
  background-color: ${props => props.theme.colors.grayLight};
`;

const SectionTitle = styled(motion.h2)`
  color: ${props => props.theme.colors.primary};
  text-align: center;
  position: relative;
  padding-bottom: 1rem;
  margin-bottom: 3rem;
  text-transform: uppercase;
  font-style: italic;
  
  &:after {
    content: '';
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
    width: 60px;
    height: 3px;
    background-color: ${props => props.theme.colors.grayMedium};
  }
`;

const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  width: 100%;
  max-width: 100%;
  
  @media (min-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Card = styled(motion.figure)`
  background-color: ${props => props.theme.colors.white};
  border-radius: ${props => props.theme.borderRadius.medium};
  box-shadow: ${props => props.theme.boxShadow};
  padding: 1.5rem;
  margin: 0;
`;

const Quote = styled.blockquote`
  margin: 0 0 1rem;
  color: ${props => props.theme.colors.black};
  font-size: ${props => props.theme.fontSizes.body};
  text-align: justify;
  text-justify: inter-word;
`;

const Author = styled.figcaption`
  color: ${props => props.theme.colors.grayMedium};
  font-size: ${props => props.theme.fontSizes.small};
`;

const Testimonials = () => {
  const items = [
    {
      quote: 'A LM Consulting foi essencial para agilizar nosso processo de certificação com qualidade e segurança.',
      author: 'Maria Silva — Gerente de P&D'
    },
    {
      quote: 'Equipe técnica excelente e atendimento sempre disponível. Recomendamos sem hesitar.',
      author: 'Carlos Pereira — Diretor Industrial'
    },
    {
      quote: 'Reduzimos custos e tempo graças à experiência da equipe da LM Consulting.',
      author: 'Ana Souza — Engenheira Eletricista'
    }
  ];
  
  return (
    <TestimonialsSection id="depoimentos">
      <div className="container">
        <SectionTitle
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.6 }}
        >
          O Que Dizem Nossos Clientes
        </SectionTitle>
        <TestimonialsGrid>
          {items.map((t, i) => (
            <AnimatedSection key={i} animation="fadeIn" delay={0.1 * i}>
              <Card
                whileHover={{ y: -6, boxShadow: '0 10px 24px rgba(0,0,0,0.12)' }}
                transition={{ type: 'spring', stiffness: 300 }}
              >
                <Quote>“{t.quote}”</Quote>
                <Author>— {t.author}</Author>
              </Card>
            </AnimatedSection>
          ))}
        </TestimonialsGrid>
      </div>
    </TestimonialsSection>
  );
};

export default Testimonials;
